// Nombre del documento de identidad según el país de operación del operador.
//
// Es el MISMO mapeo que la app del repartidor (constants/countryProfiles.ts): el operador
// configura "pedir el documento" acá y el repartidor tiene que ver la misma palabra en el
// formulario, si no parecen dos cosas distintas. El backend manda el país (ISO-2), no la
// etiqueta, justamente para no tener el texto duplicado en tres lugares con riesgo de
// desincronizarse; este archivo es la copia de la web.
//
// Nombre propio: NO se traduce (un RUT se llama RUT en cualquier idioma).

const LABEL_BY_COUNTRY = {
  AR: "DNI",
  CL: "RUT",
  CO: "Cédula",
  PE: "DNI",
};

/** Etiqueta del documento para un ISO-2. Cae a "Documento" si el país no se reconoce. */
export function identityDocumentLabel(countryCode) {
  if (typeof countryCode !== "string") return "Documento";
  return LABEL_BY_COUNTRY[countryCode.trim().toUpperCase()] ?? "Documento";
}
